import { createFileRoute } from "@tanstack/react-router";

import FounderSupportPage from "@/founder/support/page";

export const Route = createFileRoute("/founder/support/")({
    component: RouteComponent,
});

function RouteComponent() {
    return <FounderSupportPage />;
}
